import { AxiosInstance, AxiosPromise } from 'axios';

import {
  CompanyServiceEndpoint,
  GetCompanyResponse,
  UpdateCompanyRequest,
} from './CompanyService.types';
import { BaseRequest } from '@trukt/types/BaseRequest';
import { SimplePaginatedResults } from '@trukt/types/PaginatedResults';
import { PaginatedQueryParams } from '@trukt/types/PaginatedQueryParams';

export type GetCompanyListRequest = BaseRequest<Pick<PaginatedQueryParams, 'pg' | 'rc' | 'search'>>;
export type GetCompanyListResponse = SimplePaginatedResults<{
  guid: string;
  name: string;
  email: string | null;
  phoneNumber: string | null;
  mobileNumber: string | null;
  website: string | null;
  active: boolean;
  status: string | null;
  usdot: string | null;
  mc: string | null;
  ff: string | null;
  mx: string | null;
  scac: string | null;
}>;

export class CompanyService implements CompanyServiceEndpoint {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  get() {
    return this.instance.get<GetCompanyResponse>('/company');
  }

  getList({ queryParams }: GetCompanyListRequest) {
    return this.instance.get<GetCompanyListResponse>('/companies', {
      params: queryParams,
    });
  }

  update({ body }: UpdateCompanyRequest): AxiosPromise {
    return this.instance.patch<void>('/company', body);
  }
}
